type IAuthRoute = {
  children: any;
  meta: Record<string, any> | null;
};
function PswLogin(props: IAuthRoute) {
  return props.children;
}

export default PswLogin;
